var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import classNames from 'classnames';
import styles from './ProductPodImage.module.scss';
var ProductPodImage = function (_a) {
    var _b;
    var name = _a.name, disabled = _a.disabled, imageUrl = _a.imageUrl, className = _a.className, loading = _a.loading;
    if (!imageUrl)
        return null;
    return (React.createElement("div", __assign({}, __assign({ className: classNames(className, styles.productPodImage, (_b = {},
            _b[styles.disabled] = disabled,
            _b)) }, {
        'data-actiontype': 'redirect',
        'data-origincomponent': 'ProductPod',
        'data-shortdescription': "view product details for ".concat(name),
    })),
        React.createElement("span", { className: styles.productPodImageSr }, "view product details for"),
        React.createElement("div", { className: styles.placeholder },
            React.createElement("img", { src: imageUrl, alt: name, itemProp: "image", loading: loading }))));
};
export default memo(ProductPodImage);
//# sourceMappingURL=ProductPodImage.js.map